// @ts-ignore
import CS from 'src/ui/country-selector/flags/cs.svg'
// @ts-ignore
import EN from 'src/ui/country-selector/flags/en.svg'
// @ts-ignore
import SK from 'src/ui/country-selector/flags/sk.svg'
// @ts-ignore
import UK from 'src/ui/country-selector/flags/uk.svg'
// @ts-ignore
import PL from 'src/ui/country-selector/flags/pl.svg'
// @ts-ignore
import HU from 'src/ui/country-selector/flags/hu.svg'
// @ts-ignore
import RO from 'src/ui/country-selector/flags/ro.svg'
// @ts-ignore
import IT from 'src/ui/country-selector/flags/it.svg'
// @ts-ignore
import DE from 'src/ui/country-selector/flags/de.svg'

// for flags .svg files check https://www.npmjs.com/package/react-flags-select

export default {
    CS,
    EN,
    SK,
    UK,
    PL,
    HU,
    RO,
    IT,
    DE
}
